import {
  type GetMerchantCarriersQuery,
  type GetMerchantCarriersQueryVariables,
  useGetMerchantCarriersQuery,
} from "@/__generated__/graphql";
import { useBranding } from "@/providers/branding-provider";
import type { QueryHookOptions } from "@apollo/client";
import { useEffect } from "react";
import { useGraphQLError } from "./use-graphql-error";

export function useGetMerchant(
  options?: QueryHookOptions<
    GetMerchantCarriersQuery,
    GetMerchantCarriersQueryVariables
  >,
) {
  const { handleError } = useGraphQLError();
  const branding = useBranding();

  const { data, loading, error, refetch } = useGetMerchantCarriersQuery({
    variables: { id: branding.merchantId },
    fetchPolicy: "cache-first",
    ...options,
  });

  useEffect(() => {
    if (error) {
      handleError(error as Error, () => refetch());
    }
  }, [error, handleError, refetch]);

  return { merchant: data?.merchant, loading, error };
}
